




























































































































































































































import { $t } from '@/utils';
import omit from 'lodash/omit';
import api from '@/modules/content/wizard/api';
import NxForm from '@/modules/form/Form.vue';
import NxSimpleDialog from '@/components/dialogs/SimpleDialog.vue';
import NxSortableList from '@/components/list/legacy/SortableList.vue';
import NxZipSelector, { UncompressedImage } from '@/modules/file/selectors/ZipSelector.vue';
import Wizard from '@/modules/content/wizard/ContentWizard.vue';
import { mapGetters } from 'vuex';
import { imageWizard } from '@/modules/content/config';
import wizardConfig from '@/modules/content/wizard/config/wizard';
import NxUploadFile from '@/modules/upload/UploadFile.vue';
import NxWizardMultipleImagesStep2 from '@/modules/content/wizard/components/WizardMultipleImagesStep2.vue';
import { chunk, isArray } from 'lodash';

enum MultipleImagesCreationOptions {
  FROM_ZIP = 'ZIP',
  MULTIPLE_UPLOAD = 'MULTIPLE_UPLOAD'
}

type ImageId = number;

type ImagePayload = {
  autopublish: boolean;
  context: object;
  title: string;
  mainTaxonomyId: number;
};

type MultipleImagesPayload = {
  context: object;
  title: string;
  mainTaxonomyId: number;
  imagesId: ImageId[];
};

const CREATE_PARALLEL_REQUESTS = 5;
export default {
  name: 'nx-wizard-multiple-images',
  extends: Wizard,
  components: {
    NxForm,
    NxZipSelector,
    NxSimpleDialog,
    NxSortableList,
    NxUploadFile,
    NxWizardMultipleImagesStep2,
  },
  props: {
    type: {
      type: String,
      default: 'image',
    },
    defaultCreateOption: {
      type: String,
    },
  },
  data(): {
    uploadOptions: object;
    multipleImagesCreationOption: string;
    multipleImagesCreationOptions: object[];
    imagesFile: UncompressedImage[];
    createdImagesId: ImageId[];
    failedImages: UncompressedImage[];
    showRetryDialog: boolean;
    isUploadingFiles: boolean;
    step: number;
    everyFormIsValid: boolean,
    creatingMultipleImages: boolean;
    } {
    return {
      uploadOptions: {
        maximum: 30,
        extensions: 'jpg,jpeg',
        accept: imageWizard.allowedMimes,
        size: 100 * 1000000, // 100 Mb
      },
      multipleImagesCreationOption: this.defaultCreateOption || wizardConfig.config.photoGalleryDefaultCreateOption,
      multipleImagesCreationOptions: [
        { text: $t(`message.wizard.photoGallery.createOption.${MultipleImagesCreationOptions.FROM_ZIP}`), value: MultipleImagesCreationOptions.FROM_ZIP },
        { text: $t(`message.wizard.photoGallery.createOption.${MultipleImagesCreationOptions.MULTIPLE_UPLOAD}`), value: MultipleImagesCreationOptions.MULTIPLE_UPLOAD },
      ],
      imagesFile: [],
      createdImagesId: [],
      failedImages: [],
      showRetryDialog: false,
      isUploadingFiles: false,
      step: 1,
      everyFormIsValid: false,
      creatingMultipleImages: false,
    };
  },
  computed: {
    ...mapGetters(['context']),
    step2Component() {
      return wizardConfig.NxWizardMultipleImagesStep2;
    },
    isEmpty() {
      return this.imagesFile.length === 0;
    },
    isMultipleImagesFromZip(): boolean {
      return (
        this.multipleImagesCreationOption === MultipleImagesCreationOptions.FROM_ZIP
      );
    },
    isMultipleImagesFromMultipleUpload(): boolean {
      return (
        this.multipleImagesCreationOption === MultipleImagesCreationOptions.MULTIPLE_UPLOAD
      );
    },
    isValidZip(): boolean {
      return this.imagesFile.length > 0 && this.isMultipleImagesFromZip;
    },
    isUploadingImages(): boolean {
      return false;
    },
    imageUploadingErrors(): boolean {
      return this.failedImages.length > 0;
    },
  },
  methods: {
    nextStep() {
      this.imagesFile.forEach((file: UncompressedImage) => {
        Object.assign(file, { draft: this.draft });
      });
      this.$nextTick(() => {
        this.step = 2;
      });
    },
    onNewFileMultipleUpload(data) {
      console.debug('on onNewFileMultipleUpload', data);
      const extension = data.file.name.split('.').pop()!;
      const name = data.file.name;
      const file = data.file;
      const blobUrl = data.blob;
      const uncompressedImage: UncompressedImage = {
        extension,
        file,
        name,
        blobUrl,
        state: 'PENDING',
        draft: this.draft,
      };
      this.imagesFile.push(uncompressedImage);
    },
    async retryImageCreation(item: UncompressedImage) {
      item.state = 'PROCESSING';
      const index = this.failedImages.indexOf(item);
      const failedItem = this.failedImages[index];
      await this.createImage(failedItem);
    },
    async createImage(image: UncompressedImage) {
      const imageData = omit(image, ['name', 'blobUrl', 'extension', 'file', 'state']);
      const payload: ImagePayload = {
        ...imageData,
        autopublish: true,
        context: this.context,
        title: image.name,
        mainTaxonomyId: this.draft.mainTaxonomyId,
        ...image.draft,
      };

      const data = new FormData();
      data.append('file', image.file);
      data.append('payload', JSON.stringify(payload));
      image.state = 'PROCESSING';
      const result: any = await api.create(data, 'image');
      if (!result) {
        image.state = 'FAILED';
        this.failedImages.push(image);
      } else {
        image.state = 'SUCCESS';
        this.createdImagesId.push(result.id);
      }
    },
    async createMultipleImages() {
      this.isUploadingFiles = true;
      this.loading = true;
      // eslint-disable-next-line

      const chunks = chunk(this.imagesFile, CREATE_PARALLEL_REQUESTS);

      // eslint-disable-next-line no-restricted-syntax
      for await (const requests of chunks) {
        await Promise.all(requests.map(this.createImage));
      }

      this.loading = false;
      if (this.failedImages.length === 0) {
        this.$router.push({ name: 'searcher', params: { entity: 'content' }, query: { type: 'image' } });
        this.onDismiss();
        return;
      }
      this.showRetryDialog = true;
    },
    omitFailures() {
      this.onDismiss();
    },
    onZipSelected(files: UncompressedImage[]) {
      this.imagesFile = files.sort((a, b) => (a.name < b.name ? -1 : 1))
        .map(file => Object.assign(file, { draft: this.draft }));
    },
    onDismiss() {
      this.$emit('dismiss');
      this.imagesFile = [];
      this.draft.title = '';
      this.draft.signatureAuthorName = '';
      this.draft.mainTaxonomyId = null;
      this.step = 1;
      this.multipleImagesCreationOption = MultipleImagesCreationOptions.EMPTY;
    },
  },
};
